export const ACTION_TYPE = 'actionType';
export const CAMPAIGN_ID = 'campaignId';
export const STATUS = 'status';